import { Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useTemplateCategoriesContext } from '../contexts/TemplateCategoriesContext';
import FormSubcategory from './FormSubcategory';

export default function ModalSubcategory() {
  const { modals, state: { category } } = useTemplateCategoriesContext();

  return (
    <Modal 
      variant="form"
      isOpen={modals.subcategory.isOpen} 
      onClose={modals.subcategory.onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
        { category ? 'Editar subcategoria' : 'Nova subcategoria' }
        </ModalHeader>
        <ModalCloseButton />
        <FormSubcategory category={category} />
      </ModalContent>
    </Modal>
  )
}